import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowLanes16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconWorkflowLanes16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 3h-3a.5.5 0 0 0-.5.5V6h4V3.5a.5.5 0 0 0-.5-.5M6 7H2v3h4zm0 4H2v2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zM2.5 2A1.5 1.5 0 0 0 1 3.5v10A1.5 1.5 0 0 0 2.5 15h3A1.5 1.5 0 0 0 7 13.5v-10A1.5 1.5 0 0 0 5.5 2zm11 1h-3a.5.5 0 0 0-.5.5V6h4V3.5a.5.5 0 0 0-.5-.5M10 9.5V7h4v2.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5m.5-7.5A1.5 1.5 0 0 0 9 3.5v6a1.5 1.5 0 0 0 1.5 1.5h3A1.5 1.5 0 0 0 15 9.5v-6A1.5 1.5 0 0 0 13.5 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowLanes16);
